export type SpacingProps = {
  m?: number | 'auto';
  mx?: number | 'auto';
  my?: number | 'auto';
  mr?: number | 'auto';
  ml?: number | 'auto';
  mt?: number | 'auto';
  mb?: number | 'auto';
  p?: number;
  px?: number;
  py?: number;
  pr?: number;
  pl?: number;
  pt?: number;
  pb?: number;
};

export type LayoutProps = {
  minWidth?: string | number;
  maxWidth?: string | number;
  minHeight?: string | number;
  maxHeight?: string | number;
  width?: string | number;
  height?: string | number;
  flex?: number;
  alignSelf?: 'auto' | 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline';
};

export function extractSpacingProps(props: SpacingProps): SpacingProps {
  const { m, mx, my, ml, mr, mt, mb, p, px, py, pl, pr, pt, pb } = props;
  return { m, mx, my, ml, mr, mt, mb, p, px, py, pl, pr, pt, pb };
}

export function extractLayoutProps(props: LayoutProps): LayoutProps {
  const { minWidth, maxWidth, minHeight, maxHeight, width, height, flex, alignSelf } = props;
  return { minWidth, maxWidth, minHeight, maxHeight, width, height, flex, alignSelf };
}
